
        // classnames-loader: automatically bind css-modules to classnames
        function interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {default: obj};
        }

        var classNames = require("!../../../node_modules/classnames/bind.js");
        var locals = interopRequireDefault(require("!!../../../node_modules/style-loader/dist/cjs.js!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../node_modules/less-loader/dist/cjs.js!./FormsHelperApplication.less")).default;
        var css = classNames.bind(locals);
        for (var style in locals) {
            if (!locals.hasOwnProperty(style)) {
                continue;
            }
            if (typeof Object.defineProperty === 'function') {
                Object.defineProperty(css, style, {value: locals[style]});
            }
            else {
                css[style] = locals[style];
            }
        }
        module.exports = css;
    